import React from "react";
import "../CSS/ProductSub.css";
import product1 from "../Assets/KitchenTowel/7.jpg";
import product2 from "../Assets/KitchenTowel/2.jpg";
import product3 from "../Assets/KitchenTowel/3.jpg";
import product4 from "../Assets/KitchenTowel/4.jpg";
import product5 from "../Assets/KitchenTowel/5.jpg";
import product6 from "../Assets/KitchenTowel/6.jpg";

function KitchenTowel() {
  window.scrollTo(0, 0);

  return (
    <div className="product-sub-main">
      <div className="product-sub-head">
        <h3>Kitchen Towel</h3>
      </div>
      <div className="product-sub-body">
        <div className="product-sub-flex">
          <img src={product1}></img>
          <img src={product2}></img>
          <img src={product6}></img>
        </div>
        <div className="product-sub-flex">
          <img src={product4}></img>
          <img src={product5}></img>
          <img src={product3}></img>
        </div>
      </div>
    </div>
  );
}
export default KitchenTowel;
